const getters = {
    state: (state) => state.state,
    authenticated: (state) => (state.fbToken && state.token) ? true : false,
    authenticatedFirebase: (state) => state.fbToken ? true : false,
    authenticatedAccount: (state) => state.token ? true : false,
    account: (state) => state.account,
    fbUser: (state) => state.fbUser,
    profile: (state) => state.profile,
    profiles: (state) => state.profiles,
    profileByID: (state) => state.profileByID,
    // profileIds: (state) => Object.keys(state.profileByID) //.map((k) => state.profiles. [k].id) || []
    profileIds: (state) => Object.keys(state.profiles).map((k) => state.profiles[k].id) || [],
    canDownloadData: (state) => state.account ? state.account.can_download_data === 1 : false,
    providerID: (state) => (state.fbUser &&
        state.fbUser.providerData &&
        state.fbUser.providerData.length > 0 &&
        state.fbUser.providerData[0]
        ? (state.fbUser.providerData[0] ||
            { providerId: '' }).providerId
        : ''),
};
export default getters;
